import Vue from 'vue';
import Vuex, { Plugin, ModuleTree, GetterTree, ActionTree, MutationTree } from 'vuex';
import * as tickets from '../store/tickets/state';
import * as user from '../store/user/state';
import { version } from '@growmark/versioning-vue';

Vue.use(Vuex);

type State = typeof state;
const state = {
  version: `${version}`.replace('v', '')
};

const actions: ActionTree<State, State> = { };
const getters: GetterTree<State, State> = { 
  site: (state: State) => `v${state.version}`
};
const mutations: MutationTree<State> = { };
const modules: ModuleTree<State> = {
  /* add modules here */
  [tickets.NAMESPACE]: tickets.module,
  [user.NAMESPACE]: user.module
};
const plugins: Array<Plugin<State>> = [
  /* add async plugins here */
  async () => { 
    await new Promise(resolve => setTimeout(resolve, Math.random() * 300));
    console.debug('plugin loaded 1');
  },
  async () => { 
    await new Promise(resolve => setTimeout(resolve, Math.random() * 10));
    console.debug('plugin loaded 2');
  },
  store => {
    (tickets.plugin as unknown as Plugin<any>)(store);
    (user.plugin as unknown as Plugin<any>)(store);
  }
];

/** Promise to handle async plugins */
const vuex = new Vuex.Store({ 
  strict: true,
  state, getters,
  mutations, actions,
  modules, plugins
});

export default vuex;